import { ISourcingToolSearchFilter } from "react-migration/domains/search/typings/SourcingToolSpecificFilterTypes";
import { SearchType } from "react-migration/domains/search/constants/searchTypes";
import { ConstrainedListFilterMust } from "react-migration/domains/search/typings/SourcingToolFilters/types";

export const PowerTypeFilter: ISourcingToolSearchFilter = {
  id: "power-type-id",
  type: "nested-checkbox",
  must: ConstrainedListFilterMust.MATCH_ALL,
  mustOptions: [ConstrainedListFilterMust.MATCH_ALL, ConstrainedListFilterMust.MATCH_NONE],
  openAllSublevelsByDefault: true,
  updateFilterDialogIsVisible: false,
  displayMessages: {
    mustOptions: {
      MATCH_ALL: "sidebar.react.search_sidebar.has_all",
      MATCH_NONE: "sidebar.react.search_sidebar.has_no",
      MATCH_ANY: "sidebar.react.search_sidebar.has_some",
    },
    allSelectedMustOptions: {
      MATCH_ALL: "sidebar.react.search_sidebar.all_amenities",
      MATCH_NONE: "sidebar.react.search_sidebar.amenities",
      MATCH_ANY: "sidebar.react.search_sidebar.amenities",
    },
  },
  values: [
    {
      name: "sidebar.react.search_sidebar.power_distance.grid_power_substations",
      key: "shortest_distance_grid_power_substations",
      checked: false,
    },
    {
      name: "sidebar.react.search_sidebar.power_distance.bulk_power_substations",
      key: "shortest_distance_bulk_power_substations",
      checked: false,
    },
    {
      name: "sidebar.react.search_sidebar.power_distance.primary_power_substations",
      key: "shortest_distance_primary_power_substations",
      checked: false,
    },
    {
      name: "sidebar.react.search_sidebar.power_distance.hv_power_substations",
      key: "shortest_distance_hv_power_substations",
      checked: false,
    },
    {
      name: "sidebar.react.search_sidebar.power_distance.power_cables",
      key: "shortest_distance_power_cables",
      checked: false,
    },
    {
      name: "sidebar.react.search_sidebar.power_distance.power_overhead_lines",
      key: "shortest_distance_power_overhead_lines",
      checked: false,
    },
    {
      name: "sidebar.react.search_sidebar.power_distance.power_towers",
      key: "shortest_distance_power_towers",
      checked: false,
    },
  ],
  searchTypes: [],
};

export const PowerDistanceFilter: ISourcingToolSearchFilter = {
  id: "power-distance-filter",
  field: "sidebar.react.search_sidebar.power_distance.power_within_distance",
  type: "number",
  value: undefined,
  displayMessages: {
    mustOption: "seems.pointless.empty_string",
  },
  rangeLimit: [0, null],
};

export const PowerFilter: ISourcingToolSearchFilter = {
  id: "power-id",
  field: "sidebar.react.search_sidebar.power_distance.title",
  type: "compound",
  must: "MATCH_ANY",
  mustOptions: ["MATCH_ANY"],
  filters: [PowerTypeFilter, PowerDistanceFilter],
  requiredFilters: "all",
  searchTypes: [SearchType.SOURCING_TOOL_UK],
  displayMessages: {
    updateTitle: "sidebar.react.search_sidebar.power_distance.distance_to_closest_power",
  },
};
